import { schema } from 'normalizr';

const roleSchema = new schema.Entity('roles');

export default roleSchema;
